$('.show-logo').on('click', function () {
    $('.popup').addClass('open');

    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);
    player.play().then(function() {
	    // the video was played
	}).catch(function(error) {
	    switch (error.name) {
	        case 'PasswordError':
	            // the video is password-protected and the viewer needs to enter the
	            // password first
	            break;

	        case 'PrivacyError':
	            // the video is private
	            break;

	        default:
	            // some other error occurred
	            break;
	    }
	});
	console.log('Play the video');
});

$('.popup').on('click', function () {
    $('.popup').removeClass('open');

    var iframe = document.querySelector('iframe');
    var player = new Vimeo.Player(iframe);
    player.pause().then(function() {
	    // the video was paused
	}).catch(function(error) {
	    switch (error.name) {
	        case 'PasswordError':
	            // the video is password-protected and the viewer needs to enter the
	            // password first
	            break;

	        case 'PrivacyError':
	            // the video is private
	            break;

	        default:
	            // some other error occurred
	            break;
	    }
	});
	console.log('Pause the video');
});